if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        if (this.id === 'SuminagashiQuickView' && this.hasAttribute('open')) {
          const opener = this.smOpener;
          const card = opener?.closest('.card-wrapper');
          if (card) {
            card.classList.add('sm-quick-view-dismissed');
            const restore = () => {
              card.classList.remove('sm-quick-view-dismissed');
              card.removeEventListener('pointermove', restore);
              card.removeEventListener('focusin', restoreKeyboardAccess);
            };
            const restoreKeyboardAccess = event => {
              if (event.target === opener) restore();
            };
            card.addEventListener('pointermove', restore, {once: true});
            card.addEventListener('focusin', restoreKeyboardAccess);
            this.openedBy = card.querySelector('.card__heading a') || this.openedBy;
          }
        }
        this.smRequest?.abort();
        this.smInert?.forEach(([el, wasInert]) => { el.inert = wasInert; });
        this.smInert = null;
        this.smRequest = null;
        this.smOpener?.removeAttribute('aria-disabled');
        this.modalContent.removeAttribute('aria-busy');
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }


      async showSuminagashi(opener) {
        this.smRequest?.abort();
        const controller = new AbortController();
        this.smRequest = controller;
        this.smOpener = opener;
        opener.setAttribute('aria-disabled', 'true');
        this.modalContent.innerHTML = '<p class="sm-qv-loading" role="status">Chargement de la fiche produit…</p>';
        this.modalContent.setAttribute('aria-busy', 'true');
        this.smInert = Array.from(document.body.children).filter(el => el !== this && !['SCRIPT','STYLE','LINK'].includes(el.tagName)).map(el => [el, el.inert]);
        this.smInert.forEach(([el]) => { el.inert = true; });
        super.show(opener);
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(opener.dataset.productUrl, {signal: controller.signal});
          if (!response.ok) throw new Error('product-unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (this.smRequest !== controller || !this.hasAttribute('open')) return;
          this.productElement = doc.querySelector('section[id^="MainProduct-"]');
          if (!this.productElement) throw new Error('product-unavailable');
          const summary = this.productElement.querySelector('.product__description p, .collapsible__description p')?.textContent.trim();
          const sourceSection = this.productElement.dataset.section;
          this.preventDuplicatedIDs();
          this.productElement.id = 'MainProduct-quickadd-' + sourceSection;
          this.productElement.dataset.section = 'quickadd-' + sourceSection;
          this.removeDOMElements();
          this.productElement.querySelectorAll('complementary-products, share-button, .product__description, collapsible-element, .button--sticky, script[type="application/ld+json"]').forEach(el => el.remove());
          const info = this.productElement.querySelector('product-info');
          if (summary && info) {
            const text = document.createElement('p');
            text.className = 'sm-qv-summary';
            text.textContent = summary.length > 240 ? summary.slice(0,237).replace(/\s+\S*$/, '') + '…' : summary;
            info.querySelector('.product__title')?.after(text);
          }
          const details = this.productElement.querySelector('.product__view-details');
          if (details) details.textContent = 'Voir la fiche complète →';
          this.productElement.querySelectorAll('variant-selects, variant-radios').forEach(el => el.dataset.updateUrl = 'false');
          this.setInnerHTML(this.modalContent, this.productElement.outerHTML);
          this.querySelectorAll('.sr-animate').forEach(el => {el.classList.add('no-animation');el.style.visibility='visible';});
          this.preventVariantURLSwitching();
          this.updateImageSizes();
          this.removeGalleryListSemantic();
          if (window.Shopify?.PaymentButton) window.Shopify.PaymentButton.init();
          this.querySelector('[role="dialog"]').setAttribute('aria-label', 'Aperçu rapide : ' + (info?.querySelector('h1')?.textContent.trim() || 'produit'));
          trapFocus(this, this.querySelector('[id^="ModalClose-"]'));
          window.dispatchEvent(new CustomEvent('quickAddModalOpened', {detail:{opener}}));
        } catch (error) {
          if (this.smRequest !== controller || !this.hasAttribute('open')) return;
          const message = document.createElement('div');
          message.className = 'sm-qv-loading';
          message.setAttribute('role','status');
          const text = document.createElement('p');
          text.textContent = 'La fiche ne peut pas être chargée pour le moment.';
          const link = document.createElement('a');
          link.href = opener.dataset.productUrl;
          link.className = 'button button--primary';
          link.textContent = 'Ouvrir la fiche produit';
          message.append(text,link);
          this.modalContent.replaceChildren(message);
          trapFocus(this, this.querySelector('[id^="ModalClose-"]'));
        } finally {
          clearTimeout(timeout);
          opener.removeAttribute('aria-disabled');
          if (this.smRequest === controller) this.modalContent.removeAttribute('aria-busy');
        }
      }

      show(opener) {
        if (this.id === 'SuminagashiQuickView') return this.showSuminagashi(opener);
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
            this.querySelectorAll('.sr-animate').forEach((element) => {
              element.classList.add('no-animation');
            });
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');

            const event = new CustomEvent('quickAddModalOpened', {
              detail: {
                opener: opener,
              },
            });
            window.dispatchEvent(event);
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
